var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.country === "CN"
    ? _c(
        "svg",
        {
          attrs: { viewBox: "0 0 30 20", xmlns: "http://www.w3.org/2000/svg" },
        },
        [
          _c("rect", { attrs: { width: "30", height: "20", fill: "#de2910" } }),
          _vm._l(_vm.cnStars, function (pos, i) {
            return _c("polygon", {
              key: i,
              attrs: {
                points: _vm.starPoints,
                transform: pos,
                fill: "#ffde00",
              },
            })
          }),
        ],
        2
      )
    : _vm.country === "JP"
    ? _c(
        "svg",
        {
          attrs: { viewBox: "0 0 30 20", xmlns: "http://www.w3.org/2000/svg" },
        },
        [
          _c("rect", {
            attrs: {
              x: "0.25",
              y: "0.25",
              width: "29.5",
              height: "19.5",
              fill: "#ffffff",
              stroke: "#999999",
              "stroke-width": "0.5",
            },
          }),
          _c("circle", {
            attrs: { cx: "15", cy: "10", r: "6", fill: "#bc002d" },
          }),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }